/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Menu, MenuItem, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TableComponent from '../../components/TableComponent';
import PassportModal from '../../Modals/passportModal';
import { Users } from '../../types/General';
import { UPDATE_TYPES } from '../../utils/enums';

type props = {
  rows: Users[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  setUsers?: any;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  handleDeleteUser: () => void;
  setModalType: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleUserUpdate: any;
};

const ApprovedDealersList = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
  setUsers,
  selectedId,
  setSelectedId,
  setModalType,
  setOpen,
  handleUserUpdate,
}: props) => {
  const navigate = useNavigate();

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Owner Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate(`/profile-detail/dealer/${row?._id}`)}>
              <img src={row?.image || '/static/images/user_placeholder.png'} alt="" />
            </figure>
            <p>
              <b>{row?.name || '-'}</b>
              {row?.dialCode} {row?.phoneNo || '-'} <br />
              {row?.email || '-'}
            </p>
          </div>
        );
      },
    },
    // {
    //   flex: 0.8,
    //   minWidth: 200,
    //   field: "storeName",
    //   headerName: "Store Details",
    //   editable: false,
    //   sortable: false,

    //   renderCell: () => {
    //     return (
    //       <div className="user_block">
    //         <figure>
    //           <img src="/static/images/car_image.jpeg" alt="" />
    //         </figure>
    //         <p>
    //           <b>Car Masters</b>
    //         </p>
    //       </div>
    //     );
    //   },
    // },
    {
      flex: 1,
      minWidth: 300,
      field: 'address',
      headerName: 'Address',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.addressObject?.address || '-'}</p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isBlocked}
            onChange={() => handleUserUpdate(row?._id, !row?.isBlocked, UPDATE_TYPES.BLOCK)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row?._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={() => navigate(`/profile-detail/dealer/${selectedId}`)}>
                  View
                </MenuItem>
                <MenuItem onClick={() => navigate(`/edit-profile-detail/dealer/${selectedId}`)}>
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl1(null);
                    setModalType('delete');
                    setOpen(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const hidden = ['fullName'];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          count={count}
          onPageChange={onPageChange}
          loading={loading}
          page={page}
          key={'_id'}
        />
      </div>

      <PassportModal open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default ApprovedDealersList;
